"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelekineticForceWaveAbilityHandler = exports.TelekineticForceWaveActorAbilityFactory = exports.TelekineticForceWaveAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Stun_1 = require("../../core/effects/core/Stun");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class TelekineticForceWaveAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TelekineticForceWave;
        this.__typeName = "TelekineticForceWave";
    }
}
exports.TelekineticForceWaveAbilityArgs = TelekineticForceWaveAbilityArgs;
let TelekineticForceWaveActorAbilityFactory = class TelekineticForceWaveActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TelekineticForceWave", "AllEnemies", 3);
    }
};
TelekineticForceWaveActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TelekineticForceWave")
], TelekineticForceWaveActorAbilityFactory);
exports.TelekineticForceWaveActorAbilityFactory = TelekineticForceWaveActorAbilityFactory;
let TelekineticForceWaveAbilityHandler = class TelekineticForceWaveAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        for (const enemy of enemies) {
            container.applyAttackWithDamage({
                sequence,
                abilityKey: ability.args.__typeName,
                attackType: "magic",
                attackerId: ability.invokerId,
                targetId: enemy,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 130)
                ],
                onHit(sequence) {
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        effect: new Stun_1.StunEffectArgs(),
                        duration: Duration_1.Duration.Turns(1),
                        sequence
                    });
                }
            });
        }
    }
};
TelekineticForceWaveAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TelekineticForceWave)
], TelekineticForceWaveAbilityHandler);
exports.TelekineticForceWaveAbilityHandler = TelekineticForceWaveAbilityHandler;
